export default "__VITE_ASSET__DdB9xKiF__"